import { AsyncResolver } from "../interfaces/AsyncResolver";
import { AsyncImportResolver } from "../interfaces/AsyncImportResolver";
import { IJsonStringResource } from "../interfaces/IJsonStringResource";

export function withImport<T = IJsonStringResource>(resolver: AsyncImportResolver<T>): AsyncResolver<T> {
    return () => resolver().then((r) => r.default);
}
